export {default} from './tooltip'



// WEBPACK FOOTER //
// ./~/muse-ui/src/tooltip/index.js